import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FragmentType } from '../../client/gql';
import { UseDMRoomsFragment } from '../../matrix/hooks/useDMRooms';
import { getMatrixRoomIdWithServerName } from '../../utils/matrixRoomId';
import { MatrixChat } from '../MatrixChat/MatrixChat';

type MatrixChatFlyoutProps = {
  query: FragmentType<typeof UseDMRoomsFragment> | undefined;
};

export const MatrixChatFlyout = ({ query }: MatrixChatFlyoutProps) => {
  const { roomId } = useParams();

  const [matrixRoomId, setMatrixRoomId] = useState<string>();

  useEffect(() => {
    if (roomId) {
      getMatrixRoomIdWithServerName(roomId).then((_matrixRoomId) => {
        if (_matrixRoomId) {
          setMatrixRoomId(_matrixRoomId);
        }
      });
    }
  }, [roomId]);

  return <MatrixChat matrixRoomId={matrixRoomId} query={query} />;
};
